import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { alcadaService } from '../services/alcadaService';
import type { CriarAlcadaRequest, AtualizarAlcadaRequest } from '../types';

export const useAlcada = () => {
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: ['alcada'],
    queryFn:  () => alcadaService.getAll(),
  });

  const criarMut = useMutation({
    mutationFn: (data: CriarAlcadaRequest) => alcadaService.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['alcada'] }),
  });

  const atualizarMut = useMutation({
    mutationFn: ({ id, data }: { id: number; data: AtualizarAlcadaRequest }) =>
      alcadaService.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['alcada'] }),
  });

  const removerMut = useMutation({
    mutationFn: (id: number) => alcadaService.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['alcada'] }),
  });

  return {
    alcadas:      query.data ?? [],
    isLoading:    query.isLoading,
    criarAlcada:  criarMut.mutateAsync,
    atualizarAlcada: atualizarMut.mutateAsync,
    removerAlcada: removerMut.mutateAsync,
    isCreating:   criarMut.isPending,
    isUpdating:   atualizarMut.isPending,
    isRemoving:   removerMut.isPending,
  };
};
